export enum FormFields {
  appNameSetting = 'appNameSetting',
  appName = 'appName',
}

export type FormValues = {
  [FormFields.appNameSetting]: 'custom' | 'default'
  [FormFields.appName]?: string
}
